import { createFileRoute } from '@tanstack/react-router'

import { PaginaUsoIa } from '@/features/uso-ia/pagina'

export const Route = createFileRoute('/$perfil/uso-ia')({
  component: Tela,
})

function Tela() {
  return <PaginaUsoIa />
}
